module.exports = __webpack_public_path__ + "img/aicpa.6230eb25.png";